import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import api from 'axios'
import responsive from 'vue-responsive'

import HomeComponent from "./components/Pages/Home/HomeComponent"
import PricingComponent from "./components/Pages/Pricing/PricingComponent"
import CasesComponent from "./components/Pages/Cases/CasesComponent"
import ContactComponent from "./components/Pages/Contact/ContactComponent"
import About from "./components/Misc/About"
import Http404 from './components/Misc/Http404'

Vue.use(VueRouter)
Vue.use(responsive)

if (process.env.NODE_ENV !== 'production') {
    api.defaults.baseURL = 'http://127.0.0.1:8000/api'
}
else {
    api.defaults.baseURL = 'https://api.vloerverwarminginfrezen.info/api'
}

Vue.config.productionTip = false

const routes = [
    {path: '*', name: 'http404', component: Http404},
    {path: '/', name: 'home', component: HomeComponent},
    {path: '/Home', name: 'home', component: HomeComponent},
    {path: '/Prices', name: 'prices', component: PricingComponent},
    {path: '/Cases', name: 'cases', component: CasesComponent},
    {path: '/Contact', name: 'contact', component: ContactComponent},
    {path: '/About', name: 'about', component: About},
]

const router = new VueRouter({
    mode: 'history',
    routes
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
